import { render, staticRenderFns } from "./BListDialog.vue?vue&type=template&id=b867d4ba&"
import script from "./BListDialog.vue?vue&type=script&lang=js&"
export * from "./BListDialog.vue?vue&type=script&lang=js&"
import style0 from "./BListDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports